<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <!--组件在设计器中的样子-->
      <el-cascader class="max-fill" size="medium" v-model="_value" disabled :placeholder="placeholder" />
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <!--组件在PC端预览及真实显示的样子-->
      <el-cascader :show-all-levels="false" :options="options" :props="{ multiple: true, emitPath: false }"
        class="max-fill" v-model="_value" size="medium" popper-class="popper-select" @change="handleChange" clearable>
      </el-cascader>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <!--组件在移动端预览及真实显示的样子-->
      <el-cascader :show-all-levels="false" :options="options" :props="{ multiple: true, emitPath: false }"
       class="max-fill" v-model="_value" size="medium" popper-class="popper-select" @change="handleChange" clearable>
      </el-cascader>
    </div>
    <div v-else>
      <!--组件在流程实例预览中，只读状态下样子-->
      <span v-for="item, index in _value" :key="item.value">
        {{ item.label }}
        <span v-if="index < _value.length - 1">，</span>
      </span>
    </div>
  </div>
</template>

<script>
//混入配置
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "ServiceItemInput",
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    __value: {
      get() {
        return this.findLabelByValue(this.options, this.value);
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      placeholder: '请选择数据'
    }
  },
  methods: {
    handleChange(e) {
      if (e.length > 0) {
        // 多选第一项，控制其他三级分类内容不可选择
        var type = '';
        this.options.forEach(item => {
          item.children.forEach(ite => {
            ite.children.forEach(it => {
              it.children.forEach(i => {
                if (i.label == e[0].label) {
                  type = it.label
                }
              })
            })
          })
        })
        this.options.forEach(item => {
          item.children.forEach(ite => {
            ite.children.forEach(it => {
              if (it.label != type) {
                it.children.forEach(i => {
                  i.disabled = true
                })
                // it.disabled = true
              }
            })
          })
        })
      } else if (e.length == 0) {
        this.options.forEach(item => {
          item.children.forEach(ite => {
            ite.children.forEach(it => {
              it.children.forEach(i => {
                  i.disabled = false
                })
              // it.disabled = false
            })
          })
        })
      }
      this.$forceUpdate()
    },
    findLabelByValue(options, value) {
      for (const option of options) {
        if (option.value === value[value.length - 1]) {
          return option.label;
        }
        if (option.children && option.children.length > 0) {
          const label = this.findLabelByValue(option.children, value);
          if (label) {
            return label;
          }
        }
      }
      return null; // 如果没有找到，返回 null 或其他默认值
    }
  }
}
</script>
<style>
.popper-select li[aria-haspopup="true"] .el-checkbox {
  display: none;
}
</style>